var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalBox"}},[_c('div',{staticClass:"modalBox",style:(("width:" + _vm.width + ";height:" + _vm.height + ";"))},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }